import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import Table from "../../../../Table";
import { ColumnDescription } from "react-bootstrap-table-next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";

import {
    DeletarMotivoInadimplenciaController,
    InserirMotivoInadimplenciaController,
    ListarMotivoInadimplenciaController,
} from "../../../../../Controllers/Cobranca/MotivoInadimplencia/MotivoInadimplenciaController";
import { IMotivoInadimplencia } from "../../../../../Interfaces/Cobranca/MotivoInadimplencia/MotivoInadimplenciaInterface";
import "./style.css";
import SpinnerComponent from "../../../../Loding/Spinner";

interface MotivoInadimplenciaFormData {
    motivo: string;
}

function MotivoInadimplencia() {
    const { register, handleSubmit, formState, reset } = useForm();

    const [lstMotivoInadimplencia, setLstMotivoInadimplencia] = useState([
        {},
    ] as Array<IMotivoInadimplencia>);

    useEffect(() => {
        ListarMotivoInadimplenciaController().then((response) => {
            setLstMotivoInadimplencia(response);
        });
    }, []);

    function updateListaMotivoInadimplencia() {
        ListarMotivoInadimplenciaController().then((response) => {
            setLstMotivoInadimplencia(response);
        });
    }

    //Tabela
    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_MOTIVO_INADIMPLENCIA",
            text: "Motivos de Inadimplência",
            formatter: rowMotivoInadimplencia,
        },
    ];
    function rowMotivoInadimplencia(cell: string, row: IMotivoInadimplencia) {
        return (
            <div className="rowCapysMI d-flex justify-content-between align-itens-center">
                <label>{row.DS_MOTIVO_INADIMPLENCIA}</label>
                <div className="d-flex flex-nowrap ml-2">
                    <button
                        className="btn  btn-sm btn-outline-danger font-weight-bold"
                        onClick={() => {
                            Swal.fire({
                                title: "Deseja apagar este motivo de inadimplência?",
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    DeletarMotivoInadimplenciaController(
                                        row.ID_CASO_COBRANCA_MOTIVO_INADIMPLENCIA
                                    ).then(() => {
                                        updateListaMotivoInadimplencia();
                                    });
                                }
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} size="lg" />
                    </button>
                </div>
            </div>
        );
    }

    const handleMotivoInadimplenciaFormSubmit = (
        formData: MotivoInadimplenciaFormData
    ) => {
        InserirMotivoInadimplenciaController({
            DS_MOTIVO_INADIMPLENCIA: formData.motivo,
            ID_CASO_COBRANCA_MOTIVO_INADIMPLENCIA: 0,
        }).then(() => {
            updateListaMotivoInadimplencia();
            reset();
        });
    };

    return lstMotivoInadimplencia.length ? (
        <>
            <div className="Row1 d-flex flex-columns row">
                <div className="col-12 collapse mb-5" id="collapseForm">
                    <h5 className="text-center">
                        Cadastre Motivo de Inadimplência
                    </h5>
                    <form
                        onSubmit={handleSubmit(
                            handleMotivoInadimplenciaFormSubmit
                        )}
                        className="w-100 d-flex justify-content-between align-itens-center"
                    >
                        <div className="w-100 h-100">
                            <input
                                type="text"
                                name="motivo"
                                className={`form-control placeholder-dark-45 h-100 ${
                                    formState.errors.motivo && "is-invalid"
                                }`}
                                placeholder="Motivo da Inadimplência"
                                ref={register({
                                    required:
                                        "Insira o motivo da inadimplência",
                                })}
                            />
                        </div>

                        <button className="btn btn-outline-success font-weight-bold ml-2 d-flex align-items-center">
                            <FontAwesomeIcon
                                icon={faPlus}
                                size="lg"
                                className="mr-1"
                            />{" "}
                            Cadastrar
                        </button>
                    </form>
                </div>

                <div className="col-12 mt-5">
                    <Table
                        keyField="ID_CASO_COBRANCA_MOTIVO_INADIMPLENCIA"
                        columns={columns}
                        data={lstMotivoInadimplencia}
                        sizePerPage={5}
                    />
                </div>
            </div>
        </>
    ) : (
        <SpinnerComponent />
    );
}

export default MotivoInadimplencia;
